import wixAnimations from 'wix-animations';
import wixWindow from 'wix-window';

$w.onReady(function () {

    console.log(wixWindow.formFactor);
    let codeAnimationHasHappened = false;

    wixWindow.formFactor === 'Mobile' && stickyFix();

    if (wixWindow.formFactor === 'Desktop' || wixWindow.formFactor === 'Tablet') {
        imageDrag();
        controlsHover();
        codeCopy();

        $w('#teamSection').onViewportEnter(() => {
            teamHover();
        });

        $w('#cmsSection').onViewportEnter(() => {
            cmsAnimation();
        });

        $w('#codeSection').onViewportEnter(() => {
            if (!codeAnimationHasHappened) {
                codeAnimation();
                codeAnimationHasHappened = true;
            }
        });

        

        //REPLACED WITH HOVER INTERACTIONS

        // $w('#businessSection').onViewportEnter(() => {
        //     businessSolutions();
        // });

        // $w('#templatesSection').onViewportEnter(() => {
        //     repeaterHover();
        // })
    }

});

// Animation for Immaged "dragged" to stage
function imageDrag() {
    let draggedImg = $w('#draggedImg');
    wixAnimations.timeline().add(draggedImg, { x: 500, duration: 0 }).play();
    let timeline = wixAnimations.timeline().add(draggedImg, { x: 0, duration: 2000, easing: 'easeOutCubic' })
    $w('#imgDragTrigger').onViewportLeave(() => {
        timeline.play();
    })
}

// Animation for Controls Container
function controlsHover(condition) {

    let controlsTrigger = $w('#controlsTrigger');
    let controlsCondition = false;

    controlsTrigger.onViewportEnter(() => {
        controlsCondition = true;
    })

    controlsTrigger.onViewportLeave(() => {
        controlsCondition = false;

    })

    let plusHover = $w('#plusHover');
    let desktopHover = $w('#desktopHover');
    let tabletHover = $w('#tabletHover');
    let mobileHover = $w('#mobileHover');
    let addPanel = $w('#addPanel');
    let plusActive = $w('#plusActive');
    let desktopTop = $w('#topPanelSvg');
    let tabletTop = $w('#tabletTop');
    let mobileTop = $w('#mobileTop');
    let fold2Desktop = $w('#fold2Desktop');
    let fold2Tablet = $w('#fold2tablet');
    let fold2Mobile = $w('#fold2Mobile');
    let draggedImg = $w('#draggedImg');
    wixAnimations.timeline().add([tabletTop, mobileTop, fold2Tablet, fold2Mobile], { opacity: 0, duration: 0 }).play();

    wixAnimations.timeline().add(addPanel, { x: -400, duration: 0 }).add(plusActive, { opacity: 0, duration: 0 }).play();
    let addPanelTimeline = wixAnimations.timeline().add(addPanel, { x: 0, duration: 600 });
    let plusTimeline = wixAnimations.timeline().add(plusActive, { opacity: 0.99, duration: 100 });

    plusHover.onMouseIn(() => {
        if (controlsCondition) {
            addPanelTimeline.play();
            plusTimeline.play();
        }

    });

    plusHover.onMouseOut(() => {
        if (controlsCondition) {
            console.log('plus out');
            addPanelTimeline.reverse();
            plusTimeline.reverse();
        }

    })

    desktopHover.onMouseIn(() => {
        if (controlsCondition) {
            wixAnimations.timeline().add([desktopTop, fold2Desktop, draggedImg], { opacity: 0.99, duration: 400 }).add([tabletTop, mobileTop, fold2Mobile, fold2Tablet], { opacity: 0, duration: 400 }, 0).play();

        }

    });

    tabletHover.onMouseIn(() => {
        if (controlsCondition) {
            wixAnimations.timeline().add([tabletTop, fold2Tablet, ], { opacity: 0.99, duration: 400 }).add([desktopTop, draggedImg, mobileTop, fold2Desktop, fold2Mobile], { opacity: 0, duration: 400 }, 0).play();

        }

    })

    mobileHover.onMouseIn(() => {
        if (controlsCondition) {
            wixAnimations.timeline().add([mobileTop, fold2Mobile], { opacity: 0.99, duration: 400 }).add([tabletTop, desktopTop, fold2Desktop, fold2Tablet, draggedImg], { opacity: 0, duration: 400 }, 0).play();
        }

    })

}

//Collabooration Section Animation Interactions 

function teamHover() {

    /////TEAM MEMBERS HOVER/////////

    let teamMembers = $w('#teamCell1, #teamCell3, #teamCell4, #teamCell5, #teamCell7, #teamCell8');

    teamMembers.forEach((teamMember) => {
        let rotatingElement = teamMember.children[0].children[1];
        let fadingContainer = teamMember.children[2];

        wixAnimations.timeline().add(fadingContainer, { x: -500, duration: 0 }).play();
        let timeline = wixAnimations.timeline()
            .add(rotatingElement, { rotate: 180, duration: 500, easing: "easeInOutCubic" })
            .add(fadingContainer, { x: 0, duration: 350, easing: "easeInOutCubic" }, 400);

        teamMember.onMouseIn((e) => {
            fadingContainer.expand();
            timeline.play();
        });
        teamMember.onMouseOut(() => {
            timeline.reverse();
        })

    })

    //////////LAURA////////////

    let lauraCell = $w('#teamCell6');
    let slideLaura = $w('#slideLaura')
    wixAnimations.timeline().add(slideLaura, { x: -500, duration: 0 }).play();
    let lauraTimeline = wixAnimations.timeline().add(slideLaura, { x: 0, duration: 350, easing: "easeInOutCubic" });
    lauraCell.onMouseIn(() => {
        lauraTimeline.play();
    })
    lauraCell.onMouseOut(() => {
        lauraTimeline.reverse();
    })

    //////////INVITE MEMBER ON CLICK//////////////

    let hoverJohn = $w('#hoverJohn');
    let imgJohn = $w('#imgJohn');
    let johnDsc = $w('#johnDsc');
    let inviteGrey = $w('#inviteGrey');
    let inviteBlue = $w('#inviteBlue');
    let johnClicked = false;

    let johnHover = wixAnimations.timeline().add(inviteBlue, { opacity: 0.99, duration: 200 })

    hoverJohn.onMouseIn(() => {
        if (!johnClicked) {
            johnHover.play();
        }
    })

    hoverJohn.onMouseOut(() => {
        if (!johnClicked) {
            johnHover.reverse();
        }
    })

    hoverJohn.onClick(() => {
        if (!johnClicked) {
            wixAnimations.timeline().add([imgJohn, johnDsc], { opacity: 0.99, duration: 200 }).play();
        }
        johnClicked = true;
    })
}

//CMS Section Animation

function cmsAnimation() {
    let cmsCard = $w('#cmsCard');
    let cmsThumb = $w('#cmsThumb');
    let cmsTrigger = $w('#cmsTrigger');
    let cmsAnimationDidHappen = false;
    wixAnimations.timeline().add([cmsThumb, cmsCard], { y: 1200, duration: 0 }).play();
    cmsCard.expand();
    cmsThumb.expand();

    cmsTrigger.onViewportEnter(() => {
        if (!cmsAnimationDidHappen) {

            wixAnimations.timeline().add([cmsThumb, cmsCard], { y: 0, duration: 2000, easing: 'easeInOutCubic' }).play();
            cmsAnimationDidHappen = true;
        }
    })

}

//Code Section Animation

function codeAnimation() {

    let gradient = $w('#codeBG');
    wixAnimations.timeline({ repeat: -1, "yoyo": true })
        .add(gradient, { scale: 1.8, rotate: 45, x: 100, duration: 15000 })
        .play();
}

function codeCopy(){
    let code = `import wixAnimations from 'wix-animations';


$w.onReady(function () {

    activateBackgroundAnimation();
 

});

function activateBackgroundAnimation() {

    let backgroundImage = $w('#backgroundImg');
    let timeline = wixAnimations.timeline({
            repeat: -1,
            "yoyo": true
        })
        .add(backgroundImage, {
            scale: 1.8,
            rotate: 45,
            x: 100,
            duration: 15000
        });

    timeline.play();
}`

    $w('#codeCopyBtn').onClick(() => {
        wixWindow.copyToClipboard(code)
            .then(() => {
               $w('#codeCopyMsg').show();
               setTimeout(()=>{
                   $w('#codeCopyMsg').hide('fade',{duration:300});
               },5000)
            })
            .catch((err) => {
                console.log(err);
            });
    })
}

// //Business Section Hover Interactions - REPLACED WITH HOVER INTERACTIONS
// function businessSolutions() {
//     let solutions = $w('#solution1,#solution2,#solution3,#solution4,#solution5');

//     solutions.forEach((solution) => {
//         wixAnimations.timeline().add(solution.children[0], { x: -200, opacity: 0, duration: 0 }).play();
//         let timeline = wixAnimations.timeline().add(solution.children[0], { x: 0, duration: 500 }).add(solution.children[0], { opacity: 1, duration: 700 }, 0);
//         solution.onMouseIn(() => {
//             timeline.play();
//         });
//         solution.onMouseOut(() => {
//             timeline.reverse();
//         })
//     })
// }

//Repeater Hover Interactions - REPLACED WITH HOVER INTERACTIONS
// function repeaterHover() {

//     $w("#repeateItem").onMouseIn((event) => {
//         let $item = $w.at(event.context);
//         wixAnimations.timeline().add($item("#buttonBox"), { opacity: 0.99, duration: 200 }).play();
//         // $item("#buttonBox").show();

//     });
//     $w("#repeateItem").onMouseOut((event) => {
//         let $item = $w.at(event.context);
//         wixAnimations.timeline().add($item("#buttonBox"), { opacity: 0, duration: 200 }).play();
//         // $item("#buttonBox").hide();

//     });
// }

function stickyFix() {
    wixAnimations.timeline().add($w('#ukraineBox'),{y:-21,duration:0}).play();
    wixAnimations.timeline().add($w('#box144'),{y:-24,duration:0}).play();
}